import React, { Component } from "react";
import PropTypes from "prop-types";
import { isEmpty, noop, map } from "lodash";
import { Link } from "react-router-dom";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReactToPrint from "react-to-print";
import { normalizeAmount, formatData } from "../../utils/transformer.util";
import {
  Button,
  Select,
  Textarea,
  SearchSelect,
} from "../../components/base/index";
import { JADWAL_MATPEL_LIST_TABLE_FIELDS } from "../../constants/Student/student.constant";

const initialContent = {
  loading: true,
  list: [],
  currentPage: 1,
  total: 1,
  totalPage: 1,
  error: false,
};

export default class LaporanMapel extends Component {
  constructor(props) {
    super(props);
    this._onSearchContent = this._onSearchContent.bind(this);
    this._onClickAdd = this._onClickAdd.bind(this);
    this._onClickCetak = this._onClickCetak.bind(this);
    this._onFormChange = this._onFormChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this._renderButtons = this._renderButtons.bind(this);
    this._getParamOptionsAcademics = this._getParamOptionsAcademics.bind(this);
    this.onClickEdit = this.onClickEdit.bind(this);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    // this._getPrmLevels = this._getPrmLevels.bind(this);
    this._onClickDetails = this._onClickDetails.bind(this);
    this._onClickBack = this._onClickBack.bind(this);
    this._getPeriodsOptions = this._getPeriodsOptions.bind(this);
    this._onClickPosting = this._onClickPosting.bind(this);
    this._ttlJP = this._ttlJP.bind(this);
    this._getNotesUnpostingSch = this._getNotesUnpostingSch.bind(this);
    this._getSchoolUnitsOptions = this._getSchoolUnitsOptions.bind(this);
    this._onClickSet = this._onClickSet.bind(this);
    this._getParamPerwakilan = this._getParamPerwakilan.bind(this);

    const { user } = this.props;
    const { school_unit } = user;
    const { levels_id } = school_unit;

    this.state = {
      page: 1,
      isTable: true,
      selected: {},
      content: initialContent,
      unchecked: {},
      filters: {},
      list: [],
      form: {
        value: {
          levels_id,
          classrooms: [],
          levels: [],
          classrooms_id: "",
          listjadwal: [],
          listDetails: [],
          user_id: user.id,
        },
        error: {
          classrooms: "",
          levels: "",
        },
      },
      param: {},
      filtered: false,
    };
  }

  componentDidMount() {
    const { user, location } = this.props;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const { organizations_id, user_group } = user;
    const { content, form, filters } = this.state;
    // console.log(data)
    //   if (isEdit && data) {
    //   this._onSearchContentDetails(data);
    // }
    let savedForm =
      JSON.parse(window.localStorage.getItem("JadwalMapelForm")) || "";
    let savedFilters =
      JSON.parse(window.localStorage.getItem("JadwalMapelFilters")) || filters;
    if (savedForm != "" && user.id != savedForm.value.user_id) {
      savedForm = "";
      savedFilters = filters;
    }
    this._initializeData(savedFilters);
    if (savedForm != "") {
      this.setState((prevState) => ({
        ...prevState,
        form: {
          ...prevState.form,
          value: {
            ...prevState.form.value,
            units_id: savedFilters.units_id ? savedFilters.units_id : "",
          },
        },
        filters: {
          ...prevState.filters,
          units_id: savedFilters.units_id ? savedFilters.units_id : "",
          // entrance_year : savedFilters.entrance_year,
        },
      }));
      if (user_group.name === "pusat" || user_group.name === "pengurus") {
        console.log(savedFilters);
        console.log(savedForm);
        this._getPeriodsOptions({
          units_id: savedFilters.units_id ? savedFilters.units_id : "",
        });
        this._getParamPerwakilan();
      }
    }
    // this._getPrmLevels({ filters: {units_id: [school_unit.id], organizations_id: organizations_id } });
  }

  async _initializeData(savedFilters = {}) {
    const { user } = this.props;
    const { content } = this.state;
    const { school_unit, user_group } = user;

    if (user_group.name !== "pusat" || user_group.name !== "pengurus") {
      await this._getPeriodsOptions({ units_id: school_unit.id });
      // this._onSearchContent();
      this._getNotesUnpostingSch();
      this._ttlJP();
    }
    await this._getSchoolUnitsOptions();
    await this._getParamPerwakilan();

    if (user_group.name == "pusat" || user_group.name === "pengurus") {
      this.setState((prevState) => ({
        filters: {
          ...prevState.filters,
          period: savedFilters.period,
        },
      }));
    } else {
      this.setState((prevState) => ({
        filters: {
          ...prevState.filters,
        },
      }));
    }
  }

  async _getParamPerwakilan(filters = {}) {
    const { getParamPerwakilan, user } = this.props;
    const { school_unit, user_group } = user;
    const { levels_id } = school_unit;
    const res = await getParamPerwakilan(filters);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        perwakilan_prm: res,
      },
    }));
  }

  async _getSchoolUnitsOptions(filters = {}) {
    const { getSchoolUnitsOptions } = this.props;
    const { form } = this.state;
    const { units_id } = form.value;
    const res = await getSchoolUnitsOptions(filters);
    const selectedUnits = res.find((item) => item.value == units_id);

    // console.log(units_id)
    this.setState((prevState) => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          levels_units: selectedUnits ? selectedUnits.attributes.levels_id : "",
        },
      },
      param: {
        ...prevState.param,
        units: res,
      },
    }));
  }

  async _getNotesUnpostingSch(payload = {}) {
    const { filters, param, form } = this.state;
    const { getNotesUnpostingSch, user, getPeriodsOptions } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    const { units_id, levels_id } = school_unit;
    console.log(form.value);
    const units =
      user_group.name == "pusat" ||
      user_group.name == "perwakilan" ||
      user_group.name === "pengurus"
        ? filters.units_id
          ? filters.units_id
          : ""
        : school_unit.id;
    console.log(units);

    const res = await getNotesUnpostingSch({
      ...payload,
      organizations_id,
      units_id: units,
      period_id: filters.period,
    });
    // filters.organizations_id = organizations_id;
    // filters.units_id = units_id;

    this.setState((prevState) => ({
      ...prevState,
      notes: res,
    }));
  }

  async _ttlJP(payload = {}) {
    const { filters, param, form } = this.state;
    const { handleGetJp, user, getPeriodsOptions } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    const { units_id, levels_id } = school_unit;
    console.log(form.value);
    const units =
      user_group.name == "pusat" ||
      user_group.name == "perwakilan" ||
      user_group.name === "pengurus"
        ? filters.units_id
          ? filters.units_id
          : ""
        : school_unit.id;
    console.log(units);

    const res = await handleGetJp({
      ...payload,
      levels_id: levels_id,
    });
    // filters.organizations_id = organizations_id;
    // filters.units_id = units_id;

    this.setState((prevState) => ({
      ...prevState,
      ttl_jp: res,
    }));
  }

  async _getPrmLevels(filters = {}) {
    const { getPrmLevels, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { units_id, levels_id } = school_unit;
    const res = await getPrmLevels(filters);
    filters.organizations_id = organizations_id;

    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        levels: res,
      },
    }));
  }

  _onClickAdd() {
    const { history } = this.props;
    const { ttl_jp } = this.state;
    history.push("/dashboard/pengaturan/tambah-jadwal-matpel", {
      isEdit: true,
      ttl_jp: ttl_jp,
    });
  }

  onClickEdit(val) {
    const { history } = this.props;
    const { ttl_jp } = this.state;
    history.push("/dashboard/pengaturan/tambah-jadwal-matpel", {
      data: val,
      ttl_jp: ttl_jp,
      isEdit: true,
    });
  }

  async _getPrmLevels(filters = {}) {
    const { getPrmLevels, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { units_id, levels_id } = school_unit;
    const res = await getPrmLevels(filters);
    filters.organizations_id = organizations_id;

    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        levels: res,
      },
    }));
  }

  _onClickCetak() {
    const { history } = this.props;
    history.push(
      "/dashboard/kurikulum/mata-pelajaran/cetak/jadwal-mata-pelajaran",
    );
  }

  async _getPeriodsOptions(filters = {}) {
    const { getPeriodsOptions } = this.props;
    const res = await getPeriodsOptions(filters);

    map(res, (data, idx) => {
      const date = new Date();
      const start_date = new Date(data.attributes.start_date);
      if (date > start_date) {
        // tahun ajaran sekarang
        this.setState((prevState) => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              periods_id: data.value,
            },
          },
          filters: {
            ...prevState.filters,
            period: data.value,
            period_label: data.label,
          },
        }));
      }
    });

    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        periods: res,
      },
    }));
  }

  async _onClickDetails(val, idx) {
    const { history } = this.props;
    history.push("/dashboard/pengaturan/data-jadwal-matpel-details", {
      data: val,
      // isEdit: true,
    });
  }

  _onClickBack() {
    window.scrollTo(0, 0);
    this.setState((prevState) => ({
      page: prevState.page - 1,
    }));
  }

  _onFormChange(event) {
    const { name, value, dataset, checked, type } = event.target;
    const {
      inputType = "text",
      inputArray = false,
      arrayPosition = 0,
      fieldName,
    } = dataset;
    const { user } = this.props;
    const { organizations_id } = user;
    this.setState(
      (prevState) => {
        let newList = [];
        let newListError = [];
        let formattedValue = value;

        if (inputType === "number") {
          formattedValue = normalizeAmount(value);
        }
        if (inputArray) {
          if (type === "checkbox") {
            formattedValue = checked;
          }
          newList = prevState.form.value[fieldName];
          newListError = prevState.form.error[fieldName];
          newList[arrayPosition][name] = formattedValue;
          if (name === "code_of_account") {
            newList[arrayPosition].isCredit = value.type;
          }
          if (!isEmpty(newListError[arrayPosition])) {
            newListError[arrayPosition][name] = "";
          }
        }
        return {
          form: {
            value: {
              ...prevState.form.value,
              ...(inputArray
                ? { [fieldName]: newList }
                : { [name]: formattedValue }),
            },
            error: {
              ...prevState.form.error,
              ...(inputArray ? { [fieldName]: newListError } : { [name]: "" }),
            },
          },
        };
      },
      () => {
        if (name === "levels_id") {
          this._getParamOptionsAcademics("classrooms", {
            levels_id: value,
            organizations_id,
          });
        }
      },
    );
  }

  async _getParamOptionsAcademics(type, filters = {}) {
    const { getParamOptionsAcademics, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { levels_id } = school_unit;

    if (type === "classrooms" || type === "classrooms") {
      filters.organizations_id = organizations_id;
      filters.units_id = school_unit.id;
    } else {
      delete filters.organizations_id;
    }
    const res = await getParamOptionsAcademics(filters, type);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        [type]: res,
      },
    }));
  }

  async _onSearchContent(params = {}) {
    const { filters, form } = this.state;
    const {
      students_id = "",
      period,
      units_id,
      menu_id = "",
      perwakilan_id,
    } = filters;
    const { periods_id } = form.value;
    const {
      handleListScheduleSubject,
      user,
      handleListReportMapel,
      handleListReportMapelPerwakilan,
      handleListReportMapelPerunit,
    } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    const units =
      user_group.name === "pusat" ||
      user_group.name === "perwakilan" ||
      user_group.name === "pengurus"
        ? units_id.value
        : school_unit.id;
    const perwakilanValue = perwakilan_id ? perwakilan_id.value : "";
    console.log(perwakilanValue);
    console.log(units_id.value);
    console.log(menu_id);
    this.setState(
      {
        content: initialContent,
      },
      async () => {
        try {
          let result = {};
          if (user_group.name == "pusat") {
            if (menu_id == "jadwal") {
              result = await handleListScheduleSubject({
                ...params,
                organizations_id,
                units_id:
                  user_group.name == "pusat" || user_group.name === "pengurus"
                    ? filters.units_id.value
                    : school_unit.id,
                periods_id: period,
                filters,
              });
            }
            if (menu_id == "mapel") {
              if (!units_id && filters.period !== "undefined") {
                result = await handleListReportMapel({
                  ...params,
                  organizations_id,
                  units_id: units,
                  periods_id: period,
                  filters,
                });
              } else if (units_id.value !== "all") {
                result = await handleListReportMapel({
                  ...params,
                  organizations_id,
                  units_id: units,
                  periods_id: period,
                  period_label: filters.period_label,
                  filters,
                });
              } else if (
                perwakilanValue === "all" &&
                units_id.value === "all"
              ) {
                result = await handleListReportMapelPerwakilan({
                  ...params,
                  organizations_id,
                  units_id: units,
                  periods_id: period,
                  period: filters.period,
                  filters,
                });
              } else if (
                perwakilanValue !== "all" &&
                units_id.value === "all"
              ) {
                console.log("test 3");

                result = await handleListReportMapelPerunit({
                  ...params,
                  organizations_id,
                  periods_id: period,
                  period: filters.period,
                  perwakilan_id:
                    user_group.name === "perwakilan"
                      ? school_unit.perwakilan_id
                      : perwakilanValue,
                  filters,
                });
              }
            } else {
              result = await handleListReportMapel({
                ...params,
                organizations_id,
                units_id:
                  user_group.name == "pusat" || user_group.name === "pengurus"
                    ? filters.units_id.value
                    : school_unit.id,
                periods_id: period,
                filters,
              });
            }
          }

          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                listjadwal: result,
              },
            },
          }));
        } catch (err) {
          // if (this.isMount) {
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                listjadwal: [],
              },
            },
          }));
        }
        // }
      },
    );
  }

  async _onSearchContentDetails(params = {}) {
    const { filters, form } = this.state;
    const { value } = form;
    const { period } = filters;
    const { location, getLevels, getclassrooms, user } = this.props;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const { user_group } = user;
    this.setState(
      {
        content: initialContent,
      },
      async () => {
        try {
          const { handlelistReportSchedule, user } = this.props;
          const { organizations_id, school_unit } = user;
          const { units_id } = school_unit;

          const result = await handlelistReportSchedule({
            ...params,
            organizations_id,
            units_id:
              user_group.name == "pusat" || user_group.name === "pengurus"
                ? filters.units_id.value
                : school_unit.id,
            // classrooms_id: classrooms_id,
            periods_id: period,

            filters,
          });
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                listDetails: result,
              },
            },
          }));
        } catch (err) {
          // if (this.isMount) {
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                listDetails: [],
              },
            },
          }));
        }
        // }
      },
    );
  }

  async onClickDelete(id) {
    const { handleDeleteScheduleSubject } = this.props;
    const res = await handleDeleteScheduleSubject(id);
    if (res) {
      this._onSearchContent();
    }
  }

  _renderButtons(data) {
    const { user } = this.props;
    const { user_group } = user;
    const button = {};

    console.log(data.is_posting);

    return (
      <td>
        <div className="table__actions">
          <Button
            onClick={() => this._onClickDetails(data)}
            title="Lihat Detail"
          />
        </div>
      </td>
    );
  }

  onSubmit(e) {
    e.preventDefault();
    // const { form} = this.state;
    const { form } = this.state;
    const { handleAddBudget, history, user } = this.props;
    const { workingUnit, prm_school_units_id } = user;

    let unit_id = prm_school_units_id;

    if (unit_id === null && workingUnit && workingUnit.id) {
      unit_id = workingUnit.id;
    }
    handleAddBudget(form.value, history.goBack, unit_id);
    // handleAddBudget(form.value, plafon, history.goBack, unit_id);
    // handleAddBudget(form.value, history.goBack, unit_id);
  }

  async _onClickPosting() {
    const { filters, form } = this.state;
    const { value } = form;
    const { period } = filters;
    const { handleGenerateSchedule, history, user } = this.props;
    const { school_unit, user_group, organizations_id } = user;
    const res = await handleGenerateSchedule({
      organizations_id: organizations_id,
      units_id: school_unit.id,
      periods_id: period,
    });
    if (res) {
      history.push("/dashboard/pengaturan/data-jadwal-matpel");

      // this._onSearchContent();
      history.go(0);
    }
  }

  _onChangeFilter(e) {
    const { target } = e;
    const { value, name } = target;
    const { user } = this.props;
    const { organizations_id } = user;
    this.setState(
      (prevState) => ({
        ...prevState,
        filters: {
          ...prevState.filters,
          [name]: value,
        },
      }),
      () => {
        window.localStorage.setItem(
          "JadwalMapelForm",
          JSON.stringify(this.state.form),
        );
        window.localStorage.setItem(
          "JadwalMapelFilters",
          JSON.stringify(this.state.filters),
        );

        if (name == "menu_id") {
          this.setState((prevState) => ({
            ...prevState,
            isTable: true,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                perwakilan_id: "",
                units_id: "",
              },
            },
          }));
        }

        if (name === "perwakilan_id") {
          this.setState((prevState) => ({
            ...prevState,
            isTable: true,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                perwakilan_id: value,
                units_id: "",
              },
            },
          }));
          this._getSchoolUnitsOptions({ perwakilan_id: value.value });
          // if(value.value ===  'all'){
          // this._onSearchContent();
          // }
        }

        if (name === "units_id") {
          const param = this.state.param.units;
          console.log(value.value);
          const levels_units = param.find((i) => i.value == value.value)
            ? param.find((i) => i.value == value.value).attributes.levels_id
            : "";

          console.log(levels_units);
          this.setState((prevState) => ({
            ...prevState,
            isTable: true,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                classrooms_id: "",
                levels_id: levels_units,
                units_id: value,
              },
            },
            filters: {
              ...prevState.filters,
              period: "",
            },
          }));
          this._getPeriodsOptions({ units_id: value.value });
        }

        if (name === "levels_id") {
          this._getParamOptionsAcademics("classrooms", {
            filters: { levels_id: value, organizations_id },
          });
        }
      },
    );
  }

  _onClickSet() {
    this.setState(
      (prevState) => ({
        ...prevState,
        isTable: false,
        filters: {
          ...prevState.filters,
        },
      }),
      () => {
        this._onSearchContent();
      },
    );
  }

  render() {
    const { form, content, param, filters, page, ttl_jp, notes, isTable } =
      this.state;
    const { value } = form;
    const { listjadwal, listDetails } = form.value;

    const { classrooms_id = "", menu_id = "", period } = filters;
    const { handleGetKelas, handleDeleteKelas, coa, classrooms, user } =
      this.props;
    const { user_group } = user;
    const menu = [
      { value: "jadwal", label: "Laporan Jadwal Mata pelajaran" },
      { value: "mapel", label: "Laporan Mata Pelajaran" },
    ];
    let menu_value = {};
    const All = [{ value: "all", label: "Semua Perwakilan", attributes: {} }];
    const AllUnit = [{ value: "all", label: "Semua Unit", attributes: {} }];
    const prm_units = param.units ? param.units : "";
    const prm_perwakilan = param.perwakilan_prm ? param.perwakilan_prm : "";

    const units_all = [...AllUnit, ...prm_units];
    const perwakilan_all = [...All, ...prm_perwakilan];
    if (user_group.name !== "pusat") {
      menu_value = "mapel";
    }
    const years = [];
    const thisyear = new Date().getFullYear();
    for (let i = 2021; i <= thisyear; i++) {
      const nextyear = Number(i) + 1;
      years.push({
        label: `${i}-${nextyear}`,
        value: i,
      });
    }
    console.log(listjadwal);
    const formattedNotes = notes
      ? notes
          .map((item) => {
            const [date, time] = item.created_at.split(" ");
            return `${date}  ${item.notes}\n${time}`;
          })
          .join("\n\n")
      : "";
       const period_label_all = years.find((i) => i.value == period)
      ? years.find((i) => i.value == period).label
      : "";
          const componentRef = React.createRef();
          const printTest = `
          @media print {
            @page {
              page-break-inside: avoid;
            }
            * {
              -webkit-print-color-adjust: exact;
            }
          }`;
    return (
      <div className="add-budget">
        <div className="absensi-rekap__custom-form-row">
          <div className="absensi-rekap__custom-form-row__field">
            <Select
              name="menu_id"
              label="Menu"
              placeholder="Pilihan"
              onChange={this._onChangeFilter}
              data={menu}
              value={user_group.name == "pusat" ? filters.menu_id : menu_value}
              disabled={user_group.name == "pusat" ? false : true}
            />
          </div>
        </div>
        {user_group.name === "pusat" || user_group.name === "pengurus" ? (
          <>
            {filters.menu_id == "mapel" ? (
              <div className="absensi-rekap__custom-form-row">
                <div className="absensi-rekap__custom-form-row__field">
                  <SearchSelect
                    noMargin
                    async={false}
                    name="perwakilan_id"
                    list={perwakilan_all}
                    inputArray
                    onClick={this._onChangeFilter}
                    placeholder="Pilih Perwakilan"
                    value={form.value.perwakilan_id}
                    rightIcon="icon-search"
                    label="Pilih Perwakilan"
                  />
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="absensi-rekap__custom-form-row">
              <div className="absensi-rekap__custom-form-row__field">
                <SearchSelect
                  noMargin
                  async={false}
                  name="units_id"
                  list={units_all}
                  inputArray
                  onClick={this._onChangeFilter}
                  placeholder="Pilih Unit"
                  value={form.value.units_id}
                  rightIcon="icon-search"
                  label="Pilih Unit"
                />
              </div>
            </div>
            <div className="absensi-rekap__custom-form-row">
              <div className="absensi-rekap__custom-form-row__field">
                <Select
                  name="period"
                  label="Tahun Ajaran"
                  onChange={this._onChangeFilter}
                  data={
                    form.value.units_id
                      ? form.value.units_id.value === "all"
                        ? years
                        : param.periods
                      : param.periods
                  }
                  placeholder="Pilihan"
                  value={period}
                />
              </div>
            </div>
          </>
        ) : (
          <div className="student-list__header">
            <div className="student-list__button">
              <Select
                name="period"
                label="Tahun Ajaran"
                onChange={this._onChangeFilter}
                data={param.periods}
                placeholder="Pilihan"
                value={period}
              />
            </div>
          </div>
        )}

        {page == 1 && (
          <>
            <Button
              className="button_save"
              title="Proses"
              onClick={this._onClickSet}
            />
             <br></br>
                    <div className="beginning-balance__button-wrapper">
                      <ReactToPrint
                        pageStyle={printTest}
                        onBeforeGetContent={() =>
                          new Promise((resolve) => {
                            setTimeout(() => {
                              this.setState({ isPrint: false }, resolve);
                            }, 500);
                          })
                        }
                        onAfterPrint={() => this.setState({ isPrint: true })}
                        trigger={() => <Button title="Cetak" />}
                        content={() => componentRef.current}
                      />
                      {/* <Button
                          title="Ekspor Excel"
                          onClick={this._onClickExcel}
                        /> */}
                      &nbsp;
                      <div style={{ marginLeft: "0rem" }} className="student-list__button">
                        <ReactHTMLTableToExcel
                          id="export-to-xls-button"
                          className="button "
                          table="printable"
                          filename={`Laporan Mata Pelajaran ${period_label_all}`}
                          sheet={period_label_all}
                          buttonText="Unduh ke Excel"
                        />
                      </div>
                    </div>

            {!isTable && (
              <>
                {menu_id == "jadwal" && (
                  <div className="student-list__button2">
                    <div className="fund-request__content">
                      <table className="table" ref={componentRef}>
                        <thead>
                          <tr>
                            <th>No</th>
                            <th style={{ width: "30%" }}>Kelas</th>
                            <th style={{ width: "10%" }}>Opsi</th>
                          </tr>
                        </thead>
                        <tbody>
                          {map(listjadwal, (list, idx) => (
                            <tr key={`budget_row_${idx}`}>
                              {
                                <>
                                  <td>{idx + 1}</td>
                                  <td>{list.class_name}</td>
                                </>
                              }
                              {this._renderButtons(list)}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
                {menu_id == "mapel" && (
                  <div className="student-list__button2">
                    <div className="fund-request__content">
                      {form.value.units_id.value !== "all" && (
                        <table className="table"  id="printable" ref={componentRef}>
                          <thead>
                            <tr>
                              <th>No</th>
                              <th>Kode Mata Pelajaran</th>
                              <th>Nama Mata Pelajaran</th>
                              <th>Pengampu</th>
                              <th></th>
                              <th>Total yang Diajar</th>
                            </tr>
                          </thead>
                          <tbody>
                            {listjadwal.length > 0 ? (
                              <>
                                {map(listjadwal, (list, listIdx) => {
                                  const hasDetail =
                                    list.details &&
                                    Array.isArray(list.details) &&
                                    list.details.length > 0;

                                  const detailCount = hasDetail
                                    ? list.details.length
                                    : 1;

                                  const totalJP = hasDetail
                                    ? list.details.reduce(
                                        (s, d) => s + Number(d.ttl_mapel || 0),
                                        0,
                                      )
                                    : 0;

                                  const rowSpan = Math.max(detailCount, 1);
                                  const firstDetail =
                                    hasDetail &&
                                    list.details[0] &&
                                    list.details[0].mapel_name
                                      ? list.details[0]
                                      : null;
                                  return (
                                    <React.Fragment key={`${listIdx}`}>
                                      <tr style={{ textAlign: "center" }}>
                                        <td rowSpan={rowSpan}>{listIdx + 1}</td>
                                        <td
                                          rowSpan={rowSpan}
                                          style={{ width: "10%" }}
                                        >
                                          {list.mapel_code}
                                        </td>
                                        <td
                                          rowSpan={rowSpan}
                                          style={{ width: "30%" }}
                                        >
                                          {list.mapel_name}
                                        </td>

                                        {/* MAPEL PERTAMA */}
                                        <td>
                                          {firstDetail
                                            ? firstDetail.staff_name
                                            : "-"}
                                        </td>
                                        <td>
                                          {firstDetail
                                            ? firstDetail.ttl_mapel
                                            : "-"}
                                        </td>
                                        {/* 🔴 TOTAL JP (KOTAK MERAH) */}
                                        <td
                                          rowSpan={detailCount}
                                          style={{
                                            fontWeight: "bold",
                                            width: "30%",
                                          }}
                                        >
                                          {totalJP || "-"}
                                        </td>
                                      </tr>

                                      {/* MAPEL LANJUTAN */}
                                      {hasDetail &&
                                        list.details.slice(1).map((dtl, i) =>
                                          dtl && dtl.mapel_name ? (
                                            <tr
                                              key={i}
                                              style={{ textAlign: "center" }}
                                            >
                                              <td style={{ width: "40%" }}>
                                                {dtl.staff_name}
                                              </td>
                                              <td style={{ width: "10%" }}>
                                                {dtl.ttl_mapel}
                                              </td>
                                            </tr>
                                          ) : null,
                                        )}
                                    </React.Fragment>
                                  );
                                })}
                              </>
                            ) : (
                              <tr>
                                <td colSpan={6}>Data Belum Ada</td>
                              </tr>
                            )}
                            {/* {map(listjadwal, (list, idx) => (
                        <tr key={`budget_row_${idx}`}>
                          {
                            <>
                              <td>{idx + 1}</td>
                              <td>{list.mapel_code}</td>
                              <td>{list.mapel_name}</td>
                              <td>{list.ttl_mapel}</td>
                            </>
                          }
                        </tr>
                      ))} */}
                          </tbody>
                        </table>
                      )}
                      {form.value.perwakilan_id.value === "all" && (
                        <table
                          className="table"
                          id="printable"
                          ref={componentRef}
                          style={{ textAlign: "center" }}
                        >
                          <thead>
                            <tr className="grey">
                              <th>No</th>
                              <th>Kode Unit</th>
                              <th>Nama Unit</th>
                              <th>Kode Mata Pelajaran</th>
                              <th>Nama Mata Pelajaran</th>
                              <th>Pengampu</th>
                              <th></th>
                              <th>Total yang Diajar</th>
                            </tr>
                          </thead>

                          <tbody>
                            {map(listjadwal, (list, listIdx) => (
                              <React.Fragment key={listIdx}>
                                {/* HEADER PER UNIT */}
                                <tr>
                                  <td
                                    colSpan={8}
                                    style={{ fontWeight: "bold" }}
                                  >
                                    {list.name}
                                  </td>
                                </tr>

                                {map(list.body, (body, bodyIdx) => {
                                  const hasData =
                                    body.res && body.res.length > 0;

                                  if (!hasData) {
                                    return (
                                      <tr key={bodyIdx} style={{textAlign:'center'}}>
                                        <td>{listIdx + 1}</td>
                                        <td>{body.unit_code}</td>
                                        <td>{body.name}</td>
                                        <td colSpan={8}>
                                          Data Belum Ada
                                        </td>
                                      </tr>
                                    );
                                  }

                                  return body.res.map((res, resIdx) => {
                                    const hasDetail =
                                      res.details &&
                                      Array.isArray(res.details) &&
                                      res.details.length > 0;

                                    const detailCount = hasDetail
                                      ? res.details.length
                                      : 1;

                                    const totalJP = hasDetail
                                      ? res.details.reduce(
                                          (s, d) =>
                                            s + Number(d.ttl_mapel || 0),
                                          0,
                                        )
                                      : 0;
                                    const rowSpan = Math.max(detailCount, 1);

                                    const firstDetail =
                                      hasDetail &&
                                      res.details[0] &&
                                      res.details[0].mapel_name
                                        ? res.details[0]
                                        : null;

                                    return (
                                      <React.Fragment
                                        key={`${bodyIdx}-${resIdx}`}
                                      >
                                        {/* BARIS PERTAMA */}
                                        <tr>
                                          {resIdx === 0 && (
                                            <>
                                              <td
                                                rowSpan={body.res.reduce(
                                                  (a, b) => {
                                                    const len =
                                                      b.details &&
                                                      b.details.length
                                                        ? b.details.length
                                                        : 1;
                                                    return a + len;
                                                  },
                                                  0,
                                                )}
                                              >
                                                {bodyIdx + 1}
                                              </td>
                                              <td
                                                rowSpan={body.res.reduce(
                                                  (a, b) => {
                                                    const len =
                                                      b.details &&
                                                      b.details.length
                                                        ? b.details.length
                                                        : 1;
                                                    return a + len;
                                                  },
                                                  0,
                                                )}
                                              >
                                                {body.unit_code}
                                              </td>
                                              <td
                                                rowSpan={body.res.reduce(
                                                  (a, b) => {
                                                    const len =
                                                      b.details &&
                                                      b.details.length
                                                        ? b.details.length
                                                        : 1;
                                                    return a + len;
                                                  },
                                                  0,
                                                )}
                                              >
                                                {body.name}
                                              </td>
                                            </>
                                          )}
                                          <td rowSpan={rowSpan}>
                                            {listIdx + 1}
                                          </td>
                                          <td
                                            rowSpan={rowSpan}
                                            style={{ width: "10%" }}
                                          >
                                            {list.mapel_code}
                                          </td>
                                          <td
                                            rowSpan={rowSpan}
                                            style={{ width: "30%" }}
                                          >
                                            {list.mapel_name}
                                          </td>

                                          {/* MAPEL PERTAMA */}
                                          <td>
                                            {firstDetail
                                              ? firstDetail.staff_name
                                              : "-"}
                                          </td>
                                          <td>
                                            {firstDetail
                                              ? firstDetail.ttl_mapel
                                              : "-"}
                                          </td>
                                          {/* 🔴 TOTAL JP (KOTAK MERAH) */}
                                          <td
                                            rowSpan={detailCount}
                                            style={{
                                              fontWeight: "bold",
                                              width: "30%",
                                            }}
                                          >
                                            {totalJP || "-"}
                                          </td>
                                        </tr>

                                        {/* MAPEL LANJUTAN */}
                                        {hasDetail &&
                                          res.details.slice(1).map((dtl, i) =>
                                            dtl && dtl.mapel_name ? (
                                              <tr key={i}>
                                                <td style={{ width: "40%" }}>
                                                  {dtl.staff_name}
                                                </td>
                                                <td style={{ width: "10%" }}>
                                                  {dtl.ttl_mapel}
                                                </td>
                                              </tr>
                                            ) : null,
                                          )}
                                      </React.Fragment>
                                    );
                                  });
                                })}
                              </React.Fragment>
                            ))}
                          </tbody>
                        </table>
                      )}
                      {form.value.perwakilan_id.value !== "all" &&
                        form.value.units_id.value === "all" && (
                          <table
                            className="table"
                            id="printable"
                            ref={componentRef}
                            style={{ textAlign: "center" }}
                          >
                            <thead>
                              <tr className="grey">
                                <th>No</th>
                                <th>Kode Unit</th>
                                <th>Nama Unit</th>
                                <th>Kode Mata Pelajaran</th>
                                <th>Nama Mata Pelajaran</th>
                                <th>Pengampu</th>
                                <th></th>
                                <th>Total yang Diajar</th>
                              </tr>
                            </thead>
                            <tbody>
                              {map(listjadwal, (list, listIdx) => {
                                const hasData = list.res && list.res.length > 0;

                                if (!hasData) {
                                  return (
                                    <tr key={listIdx}>
                                    <td>{listIdx + 1}</td>
                                      <td>{list.unit_code}</td>
                                      <td>{list.name}</td>
                                      <td
                                        colSpan={8}
                                      >
                                        Data Belum Ada
                                      </td>
                                    </tr>
                                  );
                                }
                                return list.res.map((res, resIdx) => {
                                  const hasDetail =
                                    res.details &&
                                    Array.isArray(res.details) &&
                                    res.details.length > 0;

                                  const detailCount = hasDetail
                                    ? res.details.length
                                    : 1;

                                  const totalJP = hasDetail
                                    ? res.details.reduce(
                                        (s, d) => s + Number(d.ttl_mapel || 0),
                                        0,
                                      )
                                    : 0;

                                  const rowSpan = Math.max(detailCount, 1);

                                  const firstDetail =
                                    hasDetail &&
                                    res.details[0] &&
                                    res.details[0].mapel_name
                                      ? res.details[0]
                                      : null;
                                  return (
                                    <React.Fragment
                                      key={`${listIdx}-${resIdx}`}
                                    >
                                      <tr>
                                        {resIdx === 0 && (
                                          <>
                                            <td
                                              rowSpan={list.res.reduce(
                                                (a, b) => {
                                                  const len =
                                                    b.details &&
                                                    b.details.length
                                                      ? b.details.length
                                                      : 1;
                                                  return a + len;
                                                },
                                                0,
                                              )}
                                            >
                                              {listIdx + 1}
                                            </td>
                                            <td
                                              rowSpan={list.res.reduce(
                                                (a, b) => {
                                                  const len =
                                                    b.details &&
                                                    b.details.length
                                                      ? b.details.length
                                                      : 1;
                                                  return a + len;
                                                },
                                                0,
                                              )}
                                            >
                                              {list.unit_code}
                                            </td>
                                            <td
                                              rowSpan={list.res.reduce(
                                                (a, b) => {
                                                  const len =
                                                    b.details &&
                                                    b.details.length
                                                      ? b.details.length
                                                      : 1;
                                                  return a + len;
                                                },
                                                0,
                                              )}
                                            >
                                              {list.name}
                                            </td>
                                          </>
                                        )}
                                        <td rowSpan={rowSpan}>{res.mapel_code}</td>
                                        <td rowSpan={rowSpan}>
                                          {res.mapel_name}
                                        </td>
                                        
                                        <td>
                                          {firstDetail
                                            ? firstDetail.staff_name
                                            : "-"}
                                        </td>
                                        <td>
                                          {firstDetail
                                            ? firstDetail.ttl_mapel
                                            : "-"}
                                        </td>
                                        {/* 🔴 TOTAL JP (KOTAK MERAH) */}
                                        <td
                                          rowSpan={detailCount}
                                          style={{ fontWeight: "bold" }}
                                        >
                                          {totalJP || "-"}
                                        </td>
                                      </tr>

                                      {/* MAPEL LANJUTAN */}
                                      {hasDetail &&
                                        res.details.slice(1).map((dtl, i) =>
                                          dtl && dtl.staff_name ? (
                                            <tr key={i}>
                                              <td>{dtl.staff_name}</td>
                                              <td>{dtl.ttl_mapel}</td>
                                            </tr>
                                          ) : null,
                                        )}
                                    </React.Fragment>
                                  );
                                });

                                {
                                  /* <tr>
                                                           <td
                                                             rowSpan={list.res ? list.res.length + 1 : 1}
                                                           >
                                                             {list.unit_code}
                                                           </td>
                                                           <td
                                                             rowSpan={list.res ? list.res.length + 1 : 1}
                                                           >
                                                             {list.name}
                                                           </td>
                                                           {list.res ? (
                                                             list.res.length == 0 ? (
                                                               <td colSpan={10}>Data Belum Ada</td>
                                                             ) : (
                                                               ""
                                                             )
                                                           ) : (
                                                             ""
                                                           )}
                                                         </tr> */
                                }
                                // {list.res && list.res.length > 0
                                //   ? map(list.res, (res, resIdx) => (
                                //       <tr key={`budget_row_${listIdx}_${resIdx}`}>
                                //         <td>{res.code}</td>
                                //         <td>{res.staff_nip}</td>
                                //         <td>{res.staff_name}</td>
                                //         <td>{res.position_name}</td>
                                //         <td>{res.jp}</td>
                                //         <td>{res.wajib_mengajar}</td>
                                //         <td>{res.kelmeng}</td>
                                //       </tr>
                                //     ))
                                //   : ""}
                              })}
                            </tbody>
                          </table>
                        )}
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        )}
        {page == 2 && (
          <>
            <div className="student-list__button2">
              <Button onClick={this._onClickBack} title="Kembali" />
            </div>
            <div className="student-list__button2">
              <div className="fund-request__content">
                <table
                  className="table"
                  ref={componentRef}
                  style={{ width: "150%" }}
                >
                  <thead>
                    <tr>
                      <th rowSpan={2}>Jam</th>
                      <th rowSpan={2} style={{ width: "10%" }}>
                        Pukul
                      </th>
                      <th colSpan={2}>Senin</th>
                      <th colSpan={2}>Selasa</th>
                      <th colSpan={2}>Rabu</th>
                      <th colSpan={2}>Kamis</th>
                      <th colSpan={2}>Jumat</th>
                      <th colSpan={2}>Sabtu</th>
                    </tr>
                    <tr>
                      <th style={{ width: "10%" }}>KM</th>
                      <th>KG</th>
                      <th style={{ width: "10%" }}>KM</th>
                      <th>KG</th>
                      <th style={{ width: "10%" }}>KM</th>
                      <th>KG</th>
                      <th style={{ width: "10%" }}>KM</th>
                      <th>KG</th>
                      <th style={{ width: "10%" }}>KM</th>
                      <th>KG</th>
                      <th style={{ width: "10%" }}>KM</th>
                      <th>KG</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {map(listDetails, (list, idx) => (
                      <tr key={`budget_row_${idx}`}>
                        <td>{idx+1}</td>
                        <td>{list.hour}</td>
                        {!isEmpty(list.sch) && (
                          map(list.sch, (item, idx) => (
                            <>
                            {(() => {
                              if(item.name == "Senin"){
                                return (
                                  <>
                                  <td>{item.mapel_code}</td>
                                  <td>{item.staff_code}</td>
                                  </>
                                )
                              }
                              if(item.name == "Selasa"){
                                return (
                                  <>
                                  <td>{item.mapel_code}</td>
                                  <td>{item.staff_code}</td>
                                  </>
                                )
                              }
                              if(item.name == "Rabu"){
                                return (
                                  <>
                                  <td>{item.mapel_code}</td>
                                  <td>{item.staff_code}</td>
                                  </>
                                )
                              }
                              if(item.name == "Kamis"){
                                return (
                                  <>
                                  <td>{item.mapel_code}</td>
                                  <td>{item.staff_code}</td>
                                  </>
                                )
                              }
                              if(item.name == "Jumat"){
                                return (
                                  <>
                                  <td>{item.mapel_code}</td>
                                  <td>{item.staff_code}</td>
                                  </>
                                )
                              }
                              if(item.name == "Sabtu"){
                                return (
                                  <>
                                  <td>{item.mapel_code}</td>
                                  <td>{item.staff_code}</td>
                                  </>
                                )
                              }
                            })()}
                            </>
                            
                          ))
                      )}
                      </tr>
                    ))} */}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}
LaporanMapel.propTypes = {
  handleListClassData: PropTypes.func,
  handleGetStudent: PropTypes.func,
  handleDeleteStudent: PropTypes.func,
  history: PropTypes.object.isRequired,
};
LaporanMapel.defaultProps = {
  handleListClassData: noop,
  handleGetStudent: noop,
  handleDeleteStudent: noop,
};
